import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink, MyMLink } from '../../ui-elements/MyMLink';
import { MyMProgressPartially } from '../../ui-elements/MyMProgressPartially';
import { MyMImage } from '../../ui-elements/MyMImage';
import BoxFileRequestMenu from '../../ui-parts/BoxFileRequestMenu';
import { BoxFileFavorite } from '../../ui-parts/ContentsFavorite';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { Pager } from '../../ui-parts/Pager';
import TooltipKeywordLabel from '../../ui-parts/TooltipKeywordLabel';
import { utility } from '../../utility';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { FilterMenu } from '../../ui-parts/FilterMenu';
import { IconButton } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { SortIconMenu } from '../../ui-parts/SortIconMenu';

// 2024.5.8 MyMine Version1.5対応 Add Start
// 2024.9.16 MyMine Version2.0対応 Modify Start

const ThumbnailViewCard = (props) => {
  const {
    callbackFavorite,
    screenId,
    controlSettings,
    setIsLoading,
    onClickPreview,
    keyword,
    screenSettings,
    viewItem,
  } = props;
  const apiRequest = useMyMApi(screenId);

  const { ThumbnailFilePath, DataId, NameDisp, FileSize, Extension, UploadDate, IsFavorite, DataType, Title, Description, Url, NewsType } = viewItem;


  const isPc = useMediaQuery(mediaQuery.pc);
  /**
  * Newsリンク押下時処理
  */
  const navigateNewsPage = () => {
    if (NewsType === constants.NewsType.InternalNews) {
      // InternalNews
      window.open(`${process.env.PUBLIC_URL}/MyM102/MyM501/MyM502/${DataId}`, '_blank');
      return;
    } else {
      // GlobalSiteNews
      apiRequest.requestJson('api/news/external-link-transition?newsId=' + DataId, 'GET', null, null, null);
      window.open(Url, '_blank');
    }
  }
  /**
 * お気に入り(登録/解除)押下時処理
 */
  const onClickFavorite = () => {
    setIsLoading(true);
    const callbackSuccessFavorite = () => {
      callbackFavorite(DataId);
      setIsLoading(false);
    }
    const callbackFailedFavorite = () => {
      setIsLoading(false);
    }
    apiRequest.requestJson(`api/box-file/favorite`, 'POST', callbackSuccessFavorite, callbackFailedFavorite, { Key: DataId, UnFavorite: IsFavorite })
  }

  let noImageFilePath = '';
  let imageFilePath = '';
  switch (DataType) {
    case constants.DataType.Box:
      noImageFilePath = `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgNoThumbnailImage}`;
      imageFilePath = ThumbnailFilePath ? `api/page/file?fileName=${ThumbnailFilePath}` : noImageFilePath;
      break;
    case constants.DataType.News:
      noImageFilePath = `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgNewsNoThumbnailImage}`;
      imageFilePath = ThumbnailFilePath ? `api/news/image?newsId=${DataId}&fileName=${ThumbnailFilePath}` : `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgNewsNoThumbnailImage}`;
      break;
    case constants.DataType.Contents:
      noImageFilePath = `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgContentsNoThumbnailImage}`;
      imageFilePath = controlSettings.ImageList[`imgContentsThumbnail_${DataId}`] ? `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList[`imgContentsThumbnail_${DataId}`]}` : noImageFilePath;
      break;
    default:
      break;
  }


  const styles = {
    fontSize: '1.15rem',
  };
  const ellipsisFileName = utility.convertEllipsisFormat(NameDisp, screenSettings.BoxFileNameMaxLength);
  const ellipsisNewsTitle = utility.convertEllipsisFormat(Title, screenSettings.NewsTitleMaxLength);
  const ellipsisNewsDescription = utility.convertEllipsisFormat(Description, screenSettings.NewsContentsMaxLength);
  const ellipsisContentsName = utility.convertEllipsisFormat(controlSettings.LabelList[`lblDocument_${DataId}`], screenSettings.ContentsNameMaxLength);
  const ellipsisContentsDescription = utility.convertEllipsisFormat(controlSettings.LabelList[`lblDescription_${DataId}`], screenSettings.ContentsDescriptionMaxLength);


  const [tooltipState, setTooltipState] = useState({});
  const handleTooltipToggle = (DataId) => {
    setTooltipState((prevState) => ({
      ...prevState,
      [DataId]: !prevState[DataId],
    }));
  };
  const tooltipRefs = useRef({});
  const handleClickOutside = useCallback((event) => {
    Object.keys(tooltipRefs.current).forEach((DataId) => {
      const ref = tooltipRefs.current[DataId];
      if (ref && !ref.contains(event.target)) {
        setTooltipState((prevState) => ({
          ...prevState,
          [DataId]: false,
        }));
      }
    });
  }, []);
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  return (
    <Grid item xs={isPc ? 3 : 12} lg={3}  >
      <Card sx={{ border: '2px solid #D4D4D4', borderRadius: '10px', height: isPc ? '230px' : '250px', width: '100%' }}>
        <Box padding=' 0 20px' height='100px' width='100%' sx={{ textAlign: 'center', position: 'relative', backgroundColor: 'rgb(13 13 13 / 55%)' }}>
          <img
            src={imageFilePath}
            className='d-inline'
            alt=''
            style={{
              maxWidth: '250px',
              width: 'auto',
              height: '100px',
              objectFit: 'contain',
              ...DataType === constants.DataType.Box ? { cursor: 'pointer' } : {}
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = noImageFilePath;
            }}
            onClick={(e) => { DataType === constants.DataType.Box && onClickPreview(e, DataId) }}
          />
          {
            DataType === constants.DataType.Box &&
            <Box sx={{ position: 'absolute', top: '0px', right: '0px' }}>
              <BoxFileFavorite isFavorite={IsFavorite} favoriteAction={onClickFavorite} unFavoriteAction={onClickFavorite} color='white' />
            </Box>
          }
        </Box>
        <CardContent sx={{
          padding: '5px',
          '&:last-child': {
            paddingBottom: '5px'
          },
        }} >
          <Box sx={{ height: isPc ? '125px' : '130px', overflow: 'auto' }}>
            {
              DataType === constants.DataType.Box ?
                <>
                  <MyMBlackLink component='a' sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} notUseLabel={true} onClick={(e) => { onClickPreview(e, DataId) }}>
                    <TooltipKeywordLabel
                      toolTipValue={(NameDisp !== ellipsisFileName) && NameDisp}
                      keyword={keyword}
                      value={ellipsisFileName}
                      fontSize={styles.fontSize}
                      isEllipsis={NameDisp !== ellipsisFileName}
                    />
                    {!isPc && NameDisp !== ellipsisFileName &&
                      <div ref={(el) => tooltipRefs.current[DataId] = el}>
                        <MyMTooltip
                          title={NameDisp}
                          arrow
                          open={tooltipState[DataId] || false}
                          onClose={() => handleTooltipToggle(DataId)}
                          onOpen={() => handleTooltipToggle(DataId)}

                        >
                          <IconButton
                            sx={{ marginLeft: "10px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTooltipToggle(DataId);
                            }}
                          >
                            <PendingIcon />
                          </IconButton>
                        </MyMTooltip>
                      </div>
                    }
                  </MyMBlackLink>
                  <Grid container >
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {controlSettings.LabelList.lblFileSizeTitle}
                      </MyMLabel >
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {FileSize != null ? `${utility.convertFileSize(FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}` : ''}
                      </MyMLabel >
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {controlSettings.LabelList.lblFileTypeTitle}
                      </MyMLabel >
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {Extension && Extension.toUpperCase()}
                      </MyMLabel >
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {controlSettings.LabelList.lblUploadDateTitle}
                      </MyMLabel>
                    </Grid>
                    <Grid item xs={6} lg={6}>
                      <MyMLabel fontSize='0.95rem'>
                        {utility.formatDateTime(UploadDate, 'd MMMM yyyy')}
                      </MyMLabel>
                    </Grid>
                  </Grid>
                  <Box className='text-center ' >
                    <BoxFileRequestMenu
                      screenId={screenId}
                      fileId={DataId}
                      setIsLoading={setIsLoading}
                      isFavorite={IsFavorite}
                      callbackFavorite={callbackFavorite}
                      isHiddenFavorite={true}
                      canShareContents={true}
                      thumnailViewFlg={true}
                    />
                  </Box>
                </>
                : DataType === constants.DataType.News ?
                  <>
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                      <TooltipKeywordLabel
                        toolTipValue={(Title !== ellipsisNewsTitle) && Title}
                        keyword={keyword}
                        value={ellipsisNewsTitle}
                        fontSize={styles.fontSize}
                        isEllipsis={Title !== ellipsisNewsTitle}
                      />
                      {!isPc && Title !== ellipsisNewsTitle &&
                        <div ref={(el) => tooltipRefs.current[`title-${DataId}`] = el}>
                          <MyMTooltip
                            title={Title}
                            arrow
                            open={tooltipState[`title-${DataId}`] || false}
                            onClose={() => handleTooltipToggle(`title-${DataId}`)}
                            onOpen={() => handleTooltipToggle(`title-${DataId}`)}
                          >
                            <IconButton
                              sx={{ marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTooltipToggle(`title-${DataId}`);
                              }}
                            >
                              <PendingIcon />
                            </IconButton>
                          </MyMTooltip>
                        </div>
                      }
                    </Grid>
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                      <TooltipKeywordLabel
                        toolTipValue={(Description !== ellipsisNewsDescription) && Description}
                        keyword={keyword}
                        value={ellipsisNewsDescription}
                        fontSize='0.95rem'
                        isEllipsis={Description !== ellipsisNewsDescription}
                      />
                      {!isPc && Description !== ellipsisNewsDescription &&
                        <div ref={(el) => tooltipRefs.current[`description-${DataId}`] = el}>
                          <MyMTooltip
                            title={Description}
                            arrow
                            open={tooltipState[`description-${DataId}`] || false}
                            onClose={() => handleTooltipToggle(`description-${DataId}`)}
                            onOpen={() => handleTooltipToggle(`description-${DataId}`)}
                          >
                            <IconButton
                              sx={{ marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTooltipToggle(`description-${DataId}`);
                              }}
                            >
                              <PendingIcon />
                            </IconButton>
                          </MyMTooltip>
                        </div>
                      }
                    </Grid>
                    <Grid container>
                      <Grid item xs={6} lg={6}>
                        <MyMLabel fontSize='0.95rem'>{controlSettings.LabelList.lblPublishDate}</MyMLabel>
                      </Grid>
                      <Grid item xs={6} lg={6}>
                        <MyMLabel fontSize='0.95rem'>
                          {utility.formatDateTime(UploadDate, 'd MMMM yyyy')}
                        </MyMLabel>
                      </Grid>
                    </Grid>
                    <Box
                      className='text-center'
                      sx={{
                        paddingTop: '20px'
                      }}
                    >
                      <MyMLink onClick={navigateNewsPage} >
                        {controlSettings.LabelList.lnkGoToNews}
                      </MyMLink>
                    </Box>
                  </>
                  :

                  < >
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                      <TooltipKeywordLabel
                        toolTipValue={(controlSettings.LabelList[`lblDocument_${DataId}`] !== ellipsisContentsName) && controlSettings.LabelList[`lblDocument_${DataId}`]}
                        keyword={keyword}
                        value={ellipsisContentsName}
                        fontSize={styles.fontSize}
                        isEllipsis={controlSettings.LabelList[`lblDocument_${DataId}`] !== ellipsisContentsName}
                      />
                      {!isPc && controlSettings.LabelList[`lblDocument_${DataId}`] !== ellipsisContentsName &&
                        <div ref={(el) => tooltipRefs.current[DataId] = el}>
                          <MyMTooltip
                            title={controlSettings.LabelList[`lblDocument_${DataId}`]}
                            arrow
                            open={tooltipState[DataId] || false}
                            onClose={() => handleTooltipToggle(DataId)}
                            onOpen={() => handleTooltipToggle(DataId)}

                          >
                            <IconButton
                              sx={{ marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTooltipToggle(DataId);
                              }}
                            >
                              <PendingIcon />
                            </IconButton>
                          </MyMTooltip>
                        </div>
                      }
                    </Grid>
                    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                      <TooltipKeywordLabel
                        toolTipValue={(controlSettings.LabelList[`lblDescription_${DataId}`] !== ellipsisContentsDescription) && controlSettings.LabelList[`lblDescription_${DataId}`]}
                        keyword={keyword}
                        value={ellipsisContentsDescription}
                        fontSize='0.95rem'
                        isEllipsis={controlSettings.LabelList[`lblDescription_${DataId}`] !== ellipsisContentsDescription}
                      />
                      {!isPc && controlSettings.LabelList[`lblDescription_${DataId}`] !== ellipsisContentsDescription &&
                        <div ref={(el) => tooltipRefs.current[DataId] = el}>
                          <MyMTooltip
                            title={controlSettings.LabelList[`lblDescription_${DataId}`]}
                            arrow
                            open={tooltipState[DataId] || false}
                            onClose={() => handleTooltipToggle(DataId)}
                            onOpen={() => handleTooltipToggle(DataId)}

                          >
                            <IconButton
                              sx={{ marginLeft: "10px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTooltipToggle(DataId);
                              }}
                            >
                              <PendingIcon />
                            </IconButton>
                          </MyMTooltip>
                        </div>
                      }
                    </Grid>
                    <Box
                      className='text-center'
                      sx={{
                        paddingTop: '45px'
                      }}
                    >
                      <MyMLink onClick={() => window.open(controlSettings.UrlList[`urlContents_${DataId}`], '_blank')} >
                        {controlSettings.LabelList.lnkGoToContent}
                      </MyMLink>
                    </Box>
                  </>
            }
          </Box>

        </CardContent>
      </Card>
    </Grid>
  );
}
// 2024.9.16 MyMine Version2.0対応 Modify End

const SearchResultThumbnailViewSearchResultCard = (props) => {
  const {
    screenId,
    pageNumber,
    setPageNumber,
    searchResult,
    onSortByChange,
    onClickPreview,
    controlSettings,
    messageList,
    sortByDDL,
    keyword,
    selectedSortBy,
    setIsLoading,
    searchValue,
    screenSettings,
    apliableFilterList,
    isLoading,
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    metadataList,
    setApliableFilterList,
    checkedList,
    setCheckedList
    // 2024.9.16 MyMine Version2.0対応 Modify End
  } = props;

  const theme = useTheme();

  /**
   * お気に入りコールバック処理
   * @param {number} favoriteFileId お気に入りファイルID
   */
  const callbackFavorite = (favoriteFileId) => {
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    const favoriteFile = searchResult.ItemList.find(x => x.DataId === favoriteFileId);
    // 2024.9.16 MyMine Version2.0対応 Modify End
    // お気に入り情報を更新
    favoriteFile.IsFavorite = !favoriteFile.IsFavorite;
  }
  // 2024.9.16 MyMine Version2.0対応 Modify Start
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isOpenFilterMenu, setIsOpenFilterMenu] = useState(false);
  const openFilterMenu = () => setIsOpenFilterMenu(true);
  const closeFilterMenu = () => setIsOpenFilterMenu(false);
  // 2024.9.16 MyMine Version2.0対応 Modify End
  // 2025.6.20 MyMine Version3.0対応 Add Start
  const [isHover, setIsHover] = useState(false)
  // 2025.6.20 MyMine Version3.0対応 Add End
  return (
    <OutlinedCustomCard>
    {isPc
      ?<CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: '65px' }}
        // 2025.6.20 MyMine Version3.0対応 Add Start
        title={
          <Box sx={{ display: 'inline-flex', alignItems: 'center', height: '37px', }}>
            <NavigateLink
              to='/MyM102/MyM401'
              navigateState={{
                state: {
                  searchValue: searchValue,
                  filterList: apliableFilterList,
                  selectedId: selectedSortBy
                }
              }}
              underline='none'
            >
              <Box sx={{
                paddingRight: '13px',
                display: 'flex',
                alignItems: 'center',
                opacity: '0.5',
              }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                <Box sx={{
                  padding: '0px 10px',
                }}
                  className='d-flex align-items-center justify-content-center'
                >
                  <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgListViewIcon} width='25px' />
                </Box>
                <Box
                  sx={{
                    transition: 'border-bottom 0.2s ease',
                    borderBottom: isHover && '1.5px solid #000'
                  }}
                >
                  <MyMLabel color='#000' fontSize='17px'>{controlSettings.LabelList.lblListView}</MyMLabel>
                </Box>
              </Box>
            </NavigateLink>
            <Box sx={{
              padding: '10px',
              backgroundColor: '#2b2b2b',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }} >
              <Box sx={{ paddingRight: '10px' }} className='d-flex align-items-center justify-content-center'>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgThumbnailViewIcon} width='25px' />
              </Box>
              <Box>
                <MyMLabel color='#fff' fontSize='17px' >{controlSettings.LabelList.lblThumbnailView}</MyMLabel>
              </Box>
            </Box>
          </Box>
        }
        // 2025.6.20 MyMine Version3.0対応 Add End
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <MyMDropDownList
              autoWidth={false}
              value={selectedSortBy}
              onChange={onSortByChange}
              options={sortByDDL.map((data) => ({
                value: data.value,
                text: data.text
              }))}
              sx={{ color: 'white', width: isPc ? 300 : 'calc(100% - 20px)' }} // 300pxで固定
            />
          </Box>
        }

      />
        :
        <Box sx={{ display: 'flex', flexWrap: 'wrap', background: theme.palette.background.secondary, justifyContent: 'space-between' }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              margin: '10px 0px 10px 20px'
            }}
          >
          <NavigateLink
            to='/MyM102/MyM401'
            navigateState={{
              state: {
                searchValue: searchValue,
                filterList: apliableFilterList,
                selectedId: selectedSortBy
              }
            }}
            underline='none'
          >
            <Box sx={{
              paddingRight: '13px',
              display: 'flex',
              alignItems: 'center',
              opacity: '0.5',
            }}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <Box sx={{
                paddingRight: '5px'}}
                className='d-flex align-items-center justify-content-center'
              >
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgListViewIcon} width='25px' />
              </Box>
            </Box>
          </NavigateLink>
          <Box sx={{
            padding: '10px',
            backgroundColor: '#2b2b2b',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }} >
            <Box className='d-flex align-items-center justify-content-center'>
              <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgThumbnailViewIcon} width='25px' />
            </Box>
          </Box>
        </Box>

          <Box sx={{ margin: '10px 20px 10px 10px', marginLeft: 'auto' }}>
            <SortIconMenu
              autoWidth
              value={selectedSortBy}
              onChange={(e) => onSortByChange(e)}
              options={sortByDDL.map((data) => {
                return {
                  value: data.value,
                  text: data.text
                }
              })}
            />
          <FilterMenu
            isOpenFilterMenu={isOpenFilterMenu}
            openFilterMenu={openFilterMenu}
            closeFilterMenu={closeFilterMenu}
            content={metadataList}
            controlSettings={controlSettings}
            setApliableFilterList={setApliableFilterList}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
          />
        </Box>
      </Box>
      }
      <CardContent sx={{ height: 585, overflowY: 'hidden', paddingTop: '5px', paddingLeft: isPc ? '40px' : '20px', paddingRight: isPc ? '40px' : '20px'}}>
        <MyMLabel sx={{ paddingBottom: '5px' }}>
          {controlSettings.LabelList.lblKeywordTitle}
          <MyMLabel component='span' sx={{ color: 'red' }}>{keyword}</MyMLabel>
        </MyMLabel>
        {searchResult.ItemList.length === 0
          ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0023}</MyMLabel>
          :
          <>
            <Box sx={{
              height: '100%',
              '.MuiDataGrid-root': { border: 'none', marginBottom: 4 },
            }}>
              <Box sx={{ height: isPc ? '490px' : '460px', position: 'relative', overflowY: 'auto' }}>
                {isLoading && <MyMProgressPartially />}
                <Grid container spacing={1} mb={2} >
                  {
                    searchResult.ItemList.map((item) =>
                      <ThumbnailViewCard
                        // 2024.9.16 MyMine Version2.0対応 Modify Start
                        key={item.DataId}
                        callbackFavorite={callbackFavorite}
                        screenId={screenId}
                        setIsLoading={setIsLoading}
                        onClickPreview={onClickPreview}
                        keyword={keyword}
                        screenSettings={screenSettings}
                        controlSettings={controlSettings}
                        viewItem={item}
                      // 2024.9.16 MyMine Version2.0対応 Modify End
                      />

                    )
                  }
                </Grid>
              </Box>
              <Pager
                resultListItem={searchResult}
                handleChangePage={(pageNum) => setPageNumber(pageNum)}
                labelList={controlSettings.LabelList}
                pageNumber={pageNumber}
              />
            </Box>
          </>
        }
      </CardContent>
    </OutlinedCustomCard>
  );
}
export default SearchResultThumbnailViewSearchResultCard;
// 2024.5.8 MyMine Version1.5対応 Add End